export default { FACEBOOK: 'facebook', GOOGLE: 'google', COGNITO: 'cognito', NONE: 'none' };